import { FormProvider } from 'react-hook-form'
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '../../../components/ui/tabs'
import { SellerCardDetails } from './components/SellerCardDetails'
import { SellerPerfil } from './components/SellerPerfil'
import { useSellerDetailsPageController } from './useSellerDetailsPageController'
import { Spinner } from '../../../components/ui/spinner'
import { SellerTransactionPage } from '../SellerTransactionPage'
import { SellerCommissionPage } from '../SellerCommissionPage'
import { SellerStatementPage } from '../SellerStatementPage'
import { PersonalInfo } from './components/SellerCardDetails/components/PersonalInfo'
import { TransactionDetails } from '../../../components/TransactionDetails'
import { BlockAndUnBlock } from '../../../components/BlockAndUnBlock'
import { PasswordChange } from '../../../components/PasswordChange'
import ButtonBack from '../../../components/ButtonBack'
import { useAuth } from '../../../../app/hooks/useAuth'
// import { UserPin } from '../../Perfil/components/UserPin'

export const SellerDetailsPage = () => {
  const { data, transaction, isFetching, isLoading, methods } =
    useSellerDetailsPageController()
  const { isSuperAdmin, isAdmin, isSupport } = useAuth()
  return (
    <div className="flex flex-col items-start">
      <ButtonBack label={data?.name} />

      {(isFetching || isLoading) && (
        <div className="flex h-screen w-full items-center justify-center">
          <Spinner />
        </div>
      )}

      {data && (
        <Tabs defaultValue="perfil" className="w-full">
          <TabsList className="my-10 flex justify-start gap-2 bg-transparent xs:my-4 xs:gap-6">
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="perfil"
            >
              Perfil
            </TabsTrigger>
            <TabsTrigger
              className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
              value="transactions"
            >
              Transações
            </TabsTrigger>
            {(isAdmin || isSuperAdmin || isSupport) && (
              <TabsTrigger
                className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
                value="withdraws"
              >
                Saques de comissão
              </TabsTrigger>
            )}
            {(isAdmin || isSuperAdmin || isSupport) && (
              <TabsTrigger
                className="rounded-lg border-[1px] border-[#E5E5E5] font-semibold text-black04"
                value="statement"
              >
                Extrato
              </TabsTrigger>
            )}
          </TabsList>
          <div className="flex w-full flex-col items-start gap-6 md:flex-row lg:gap-12">
            <div className="mt-2 w-full max-w-[450px] space-y-4">
              <SellerCardDetails
                _id={data._id}
                name={data.name}
                profileImageUrl={data.profileImageUrl}
                team={data.team}
                transactions={data.transactions}
                isActive={data.isActive}
                role={data.role}
                secondRole={data.secondRole}
                balance={data.balance}
              />
              <TransactionDetails
                quantityPaid={transaction?.statitics?.completed || 0}
                commissionTotal={transaction?.statitics?.completed_value || 0}
              />
              {(isSuperAdmin || isSupport || isAdmin) && (
                <>
                  <BlockAndUnBlock id={data._id} isActive={data.isActive} />{' '}
                  {data.reasonToDisable && !data.isActive && (
                    <div className="flex w-full flex-col items-start justify-start gap-2">
                      <h2 className=" text-sm text-black04 ">
                        Motivo do Bloqueio:
                      </h2>
                      <p className="text-sm font-medium">
                        {data.reasonToDisable}
                      </p>
                    </div>
                  )}
                  <PasswordChange />
                  {/* <UserPin user={data} /> */}
                </>
              )}
              <PersonalInfo data={data} />
            </div>
            <div className="w-full">
              <TabsContent value="perfil" className="w-full">
                <FormProvider {...methods}>
                  <SellerPerfil />
                </FormProvider>
              </TabsContent>
              <TabsContent value="transactions" className="w-full">
                <SellerTransactionPage />
              </TabsContent>
              <TabsContent value="withdraws">
                <SellerCommissionPage />
              </TabsContent>
              {(isAdmin || isSuperAdmin || isSupport) && (
                <TabsContent value="statement">
                  <SellerStatementPage />
                </TabsContent>
              )}
            </div>
          </div>
        </Tabs>
      )}
    </div>
  )
}
